import React from 'react';
import HowItWorks from '../components/sections/HowItWorks';
import PageHeader from '../components/ui/PageHeader';
import './StaticPage.css';

const HowItWorksPage: React.FC = () => (
  <div className="static-page">
    <PageHeader page="how" />
    <HowItWorks />
  </div>
);

export default HowItWorksPage;
